module.exports = __webpack_public_path__ + "img/ic_empty_box.c079e796.png";